import { createRoot } from "solid-js";
import { createStore } from "solid-js/store";
import { Dynamic, insert } from "solid-js/web";
import { getTiptapSolidReactiveOwner } from "./ReactiveOwner";
export class SolidRenderer {
    id;
    editor;
    element;
    dispose;
    setProps;
    constructor(component, { editor, props, as = "div", className = "" }) {
        this.id = Math.floor(Math.random() * 0xffffffff).toString();
        this.editor = editor;
        this.element = document.createElement(as);
        this.element.classList.add("solid-renderer");
        createRoot((dispose) => {
            const [reactiveProps, setProps] = createStore(props ?? {});
            this.setProps = setProps;
            if (className) {
                this.element.classList.add(...className.split(" "));
            }
            insert(this.element, <Dynamic component={component} {...reactiveProps}/>);
            this.dispose = dispose;
        }, getTiptapSolidReactiveOwner(this.editor));
    }
    updateProps(props) {
        this.setProps({
            ...props,
        });
    }
    destroy() {
        this.dispose();
        this.element.remove();
    }
}
